<template>
    <div ref="footer">
        <div class="cookies-window"
             :class="{'zero-opacity': transparentCookieWindow}"
             v-if="showCookieWindow">
            <div class="cookies-text">
                Сайт использует файлы cookies и сервис сбора технических данных его посетителей.<br>
                Продолжая использовать данный ресурс, вы автоматически соглашаетесь с использованием данных технологий.
            </div>
            <div class="cookies-btn">
                <button class="small-button"
                        @click="acceptCookies">Ok
                </button>
            </div>
        </div>

        <footer v-if="!noFooter">
            <div class="container visibility">
                <div class="copyright">2019 © Astrodesign</div>
                <div class="itbrick">
                    Разработка программы
                    <a href="https://www.itbricksoft.com/index.htm" target="_blank">IT Brick</a>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import constants from '@/constants';
    import * as Cookies from 'js-cookie';

    const cookieAcceptedValue = 'accepted';

    export default {
        name: 'Footer',

        props: ['noFooter'],

        data() {
            return {
                showCookieWindow: false,
                transparentCookieWindow: false
            }
        },

        created() {
            let acceptCookie = Cookies.get(constants.ACCEPT_COOKIE_NAME);
            this.showCookieWindow = !acceptCookie || acceptCookie !== cookieAcceptedValue;
        },

        methods: {
            acceptCookies() {
                Cookies.set(constants.ACCEPT_COOKIE_NAME, cookieAcceptedValue, {expires: 365});
                // Для срабатывания плавного css-transition
                this.transparentCookieWindow = true;
                setTimeout(() => {
                    this.showCookieWindow = false;
                }, 1000);
            }
        }
    }
</script>
